<template>

	<v-content>
		<v-container fluid >

			<div class="WebProxies">

				<v-toolbar color="#1d202c" dark>
					<v-toolbar-title>Proxies</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="loadItems()" :loading="isLoading">
						<v-icon>refresh</v-icon>
					</v-btn>
					<v-btn icon v-if="datachanged" @click="saveItems()" :loading="isSaving">
						<v-icon color="#00ff00">save</v-icon>
					</v-btn>
					<v-btn icon @click="addItem()">
						<v-icon>add_circle</v-icon>
					</v-btn>
				</v-toolbar>
				<table>
					<thead>
						<tr>
							<th width="50px">No</th>
							<th width="200px">Server</th>
							<th width="120px">Username</th>
							<th width="120px">Password</th> 
							<th width="90px">Protokol</th>
							<th width="90px">Platform</th>
							<th width="110px">AddDate</th>
							<th width="110px">UseDate</th>
							<th width="70px">UseCount</th>
							<th width=" ">LasrReferer</th> 
							<th width="30px">No</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,itemIndex) in items" :key="'item'+itemIndex">
							<td>
								<input type="text" placeholder="12" style="text-align:center"  disabled v-model="item.no">
							</td>
							<td>
								<input type="text" placeholder="örn : 88.120.52.12:54852"v-model="item.server">
							</td>
							<td>
								<input type="text" placeholder="örn : ajans360" v-model="item.username">
							</td>
							<td>
								<input type="text" placeholder="örn : ax288f" v-model="item.password">
							</td>
							<td>
								<select style="text-align:center" v-model="item.protocol">
									<option value="https">HTTPS</option>
									<option value="socket5">SOCKET5</option>
								</select>
							</td> 
							<td>
								<select style="text-align:center" v-model="item.platform">
									<option value="https">instagram</option>
									<option value="socket5">global</option>
								</select>
							</td> 
							<td>
								<input type="text" placeholder="01.01.1992" v-model="item.date_add">
							</td>
							<td>
								<input type="text" placeholder="01.01.1970" v-model="item.date_use">
							</td>
							<td>
								<input type="text" placeholder="12" style="text-align:center" disabled v-model="item.used_count">
							</td>
							<td>
								<input type="text" placeholder="" disabled v-model="item.last_referer">
							</td> 
							<td>
								<span class="removeBtn" @click="doRemoveCron(groupIndex,itemIndex)"><v-icon>cancel</v-icon></span> 
							</td> 
						</tr>
					</tbody>
				</table>

			</div>


		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "WebProxies",
		data() {
			return { 
				isLoading  : true, 
				isLoaded : false,
				isSaving : false,
				items : [],
				datachanged : true,
			}
		},
		watch:{ 
			items(){
				if(this.isLoaded){
					this.datachanged = true
				}
			}
		},
		mounted(){
			this.loadItems()
		},
		methods:{ 
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/web/proxies" ).then(response => { 
					this.items = response.body;
					setTimeout(()=>{
						this.isLoading = false; 
						this.isLoaded = true; 
						this.isSaving = false; 
						this.datachanged = false;  
					},10)
				}) 
			}, 
			addItem(){
				this.items.push({
					no : this.items.length ? this.items[this.items.length - 1].no + 1 : 1,
					server : "",
					username : "",
					password : "",
					protocol : "https",
					platform : "instagram",
					date_add : "",
					date_use : "",
					used_count : "",
					last_referer  : "",
				})
			},
			saveItems(){ 
				this.isLoading = true; 
				this.isSaving = true; 
				this.$http.post( process.env.VUE_APP_API_URL + "/web/proxies/save",{
					items : this.items
				}).then(response => {   
					this.loadItems()
				}) 
			}
		},
		computed:{
			getItemsJson(){
				return JSON.stringify(this.items)
			}
		}
	}
</script>




<style lang="less" scoped>
	.WebProxies{
		background-color: #fff;
		background-color: #242833;
		box-shadow: 0 0 10px rgba(204, 204, 204, 0.192); 
		padding:0 0 15px 0;
		table{
			margin:5px 15px 0px 15px;
  			border-collapse: collapse;
			background-color: #2e323d;
			thead{
				tr{
					th{
						color :#fff;
						line-height: 40px;
					}
				}
			}
			tbody{
				tr{ 
					td{
						padding: 5px;
						border-top:4px solid #242833;
						input,select{
							width: 100%;
							height:30px;
							line-height: 30px;
							border:1px solid #ccc;
							border:none;
							padding: 0px 5px;
							outline: none;
							transition: all .3s; 
								color : #ffF;
							&::placeholder{
								color : #888;
							}
							&:focus{
								//border:1px solid rgb(0, 97, 224);
							}
						}
						.removeBtn{
							margin-top:3px;
							display: block;
							cursor: pointer;
							&:hover{
								i{color : #a10707}
							}
						}
					}
					
					//&:nth-child(even) {background: #888;color:#fff} 
					//&:nth-child(odd) {background: #efefef} 
				}
			}
		}
	}
</style>